import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { NewsCategoryLabels } from '../util/storyblok/news-categories';

const emptyLabels: NewsCategoryLabels = {};
const NewsCategoryLabelsContext = createContext<NewsCategoryLabels>(emptyLabels);

export function NewsCategoryLabelsProvider({
  children,
  labels,
}: {
  children: ReactNode;
  labels?: NewsCategoryLabels | null;
}) {
  return (
    <NewsCategoryLabelsContext.Provider value={labels ?? emptyLabels}>
      {children}
    </NewsCategoryLabelsContext.Provider>
  );
}

export const useNewsCategoryLabels = () => useContext(NewsCategoryLabelsContext);
